/** A selectable visit-duration chip in the scheduling controls. */
export interface DurationPreset {
  label: string;
  minutes: number;
}

/** Label of the preset whose length tracks the tenant's configured hours. */
export const BUSINESS_DAY_PRESET_LABEL = 'Business hours';

/** Canonical duration presets shared by every slot picker. "Business hours" carries
 *  the 480-min fallback; call-sites that know the tenant's configured hours
 *  substitute the real business-day length. */
export const DEFAULT_DURATION_PRESETS: DurationPreset[] = [
  { label: '1h', minutes: 60 },
  { label: '2h', minutes: 120 },
  { label: '4h', minutes: 240 },
  { label: '8h', minutes: 480 },
  { label: BUSINESS_DAY_PRESET_LABEL, minutes: 480 },
];
